export default {
      id: "color_sneaker-usage",
      viewBox: "0 0 95 68",
      url: __webpack_public_path__ + "sprite.svg#color_sneaker",
      toString: function () {
        return this.url;
      }
    }